import {parseGraphQLResponse} from '@github-ui/item-picker-base/api/graphql'
import type {Project} from '@github-ui/item-picker-project-tsq/api/project'
import {useMutation} from '@github-ui/react-query'

import {apiUpdateIssueProjectBulk, type UpdateIssueProjectBulkRequest} from '../api/api-update-issue-project-bulk'

type UseUpdateIssueProjectBulkMutationInput = UpdateIssueProjectBulkRequest & {
  projects?: Project[]
}

type UseUpdateIssueProjectBulkMutationOptions = {
  onMutate: (variables: UseUpdateIssueProjectBulkMutationInput) => void
}

export function useUpdateIssueProjectBulkMutation({onMutate}: UseUpdateIssueProjectBulkMutationOptions) {
  return useMutation({
    mutationFn: async ({projects, ...request}: UseUpdateIssueProjectBulkMutationInput) => {
      const responseJson = await apiUpdateIssueProjectBulk(request)
      const responseData = parseGraphQLResponse(responseJson)
      return responseData
    },
    onMutate,
  })
}
